import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';


interface Props {
}

export default function Library(props: Props) {

    return (
        <Box component="main" sx={{ p: 3 }}>
            <Typography>
                Exercises
            </Typography>

        </Box>
    );
}